import { useState } from "react";
import Analitics from '@/shared/Analitics';
import { BannerFlotante2, BannerCollapse } from '@/shared/ContentBanner';
import DfpNews from '@/shared/DFP/News';
import Banner from "@/widgets/Banner/Templates/Banner";
import Header from '@/shared/Header';
import BannerFlotante from '@/widgets/Banner/Templates/BannerFlotante';
import { StoryContainer } from "@/templates/Clarin/RecipeNews/components";
import { StoryMainContainerRecetas } from './style';
import Meter from '@/shared/Meter';
import Footer from "@/shared/Footer";
import { ContainerAuto } from "@/shared/ContainerAuto";
import HeadNews from "@/shared/HeadNews";
import { ImagesSlider } from "@/shared/ImagesSlider";
import TemplateProvider from "@/context/Template/TemplateProvider.jsx";
import { useRecipeNews } from "./hooks/useRecipeNews";
import RecipesIA from '@/widgets/Misc/Templates/RecipesIA';
import { useHandleCollections } from 'hooks';

const RecipeNews = (props) => {

  const {
    formatContent,
    isPreview = false } = useRecipeNews(props);
  const handleCollections = useHandleCollections(props?.properties?.url);
  const [savedNoteStatus, setSavedNoteStatus] = useState(0);

  return (
    <TemplateProvider data={{ ...props, content: formatContent, isNews: false, handleCollections, savedNoteStatus, setSavedNoteStatus }} >
      <HeadNews />
      {!isPreview && <Analitics />}
      <DfpNews />
      <Header/>
      {
        formatContent?.isSupportedBrowser && <ImagesSlider />
      }
      <BannerFlotante isPreview={isPreview} slotId={"1"} />
      <BannerFlotante2>
        <BannerFlotante isPreview={isPreview} slotId={"2"} />
      </BannerFlotante2>
      {formatContent?.showRewarded && <Rewarded />}

      <ContainerAuto>
        <StoryMainContainerRecetas>          
          <StoryContainer />
        </StoryMainContainerRecetas>
        <BannerCollapse>
          <Banner isPreview={isPreview} slotId={"horizontal3"} adsPath={formatContent?.storyContainer?.data?.adsPath} />
        </BannerCollapse>
      </ContainerAuto>
      {!isPreview &&
        <>
          {formatContent?.metadata?.autoRefresh && <Autorefresh timerRefresh={600} />}
          <Meter />
        </>
      }
      <Footer />
    </TemplateProvider>
  )
}

export default RecipeNews;